import '../assets/edit.scss'
import TomSVideoPlayer from './video'

import React from "react";

function EditTomSVideoPlayer(tomsProps) {
    /*console.log(tomsProps)*/
    return (
    <>
    <div className="toms-video-player">
        <TomSVideoPlayer {...tomsProps}/>
    </div>
    </>
    )
}

export default EditTomSVideoPlayer;